<script setup>
import { ElPagination } from 'element-plus'
const lang1 = useI18n().locale.value;
const PATH_A = ref('')
const list = ref([])
const total = ref(0)
PATH_A.value = lang1 == 'cn' ? 'https://forthright-sec.com.hk' : ('https://forthright-sec.com.hk/' + lang1);
const asyncData = async () => {
  let lang = '';
  if (lang1 === 'en') {
    lang = 'EN';
  }
  const { currentPage, data, listRow, totalPage } = await getAnnouncement({ lang })
  list.value = data.list || []
  total.value = data.total || 0
}
asyncData()
const handleCurrentChange = async (page) => {
  const { data } = await getNotice({ p: page })
  list.value = data.list;

}
const pageCallback = (val) => {
  getNotice(val.currentPage);
}
const link = (path) => {
  if (lang1 == 'cn') {
    return path;
  }
  else {
    return `/${lang1}${path}`;
  }
}
</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24>
      <div class="about-warp__right--title">
      {{ $t('fdgg') }}
    </div>
    <div class="about-warp__right--content notice-box" mt-24>
      <ul class="notice-box__list">
        <a
          target="_blank"
          :href='PATH_A + "/notice/detail/?id=" + item.id '
          v-for="(item, index) in list" :key="index"
          class="notice-box__list--item">
          <span class="notice-box__list--item_title">{{ item.title }}</span>
          <span class="notice-box__list--item_date">{{ item.date }}</span>
        </a>
      </ul>
      <div v-if='total > 20' class="notice-box__page">
        <el-pagination
          background
          :page-size="20"
          @current-change="handleCurrentChange"
          layout=" prev, pager, next"
          :total="Number(total)"
          :next-text="'>'"
          :prev-text="'<'">
        </el-pagination>
      </div>

    </div>
    <nuxt-child/>
  </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";


.notice-box {
  padding-bottom: 60px;
  position: relative;

  &__list {
    &--item {
      display: block;
      color: #0D0E14;
      margin-bottom: 20px;
      .font-size-line(14, 20);

      &_title {
        color: #0D0E14;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      &_date {
        color: #61676B;
        float: right;
      }
    }
  }

  &__page {
    position: absolute;
    right: 0;
    bottom: 25px;
    text-align: right;
  }
}
</style>
